import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth /* connectAuthEmulator */ } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import {
  getMessaging,
  onMessage,
  getToken,
  isSupported,
  Messaging,
} from "firebase/messaging";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentSingleTabManager,
  persistentMultipleTabManager,
} from "firebase/firestore";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  ReCaptchaV3Provider,
} from "firebase/app-check";

// import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
// const db = getFirestore(app);
const db = initializeFirestore(app, {
  localCache: persistentLocalCache(),
});
const storage = getStorage(app);
const functions = getFunctions(app, 'asia-south1');
let messaging: Messaging | null = null;
(async () => {
  try {
    // First check if messaging is supported before initializing
    if (
      typeof window !== "undefined" &&
      "navigator" in window &&
      "serviceWorker" in navigator &&
      "addEventListener" in window &&
      (await isSupported())
    ) {
      messaging = getMessaging(app);
      // Your messaging logic here
    } else {
      console.log("Firebase messaging not supported in this browser");
    }
  } catch (error) {
    // Silently handle the error
    console.log("Firebase messaging initialization failed", error);
  }
})();

// Initialize App Check
const AppCheckInstance = (window as any).AppCheckInstance;

if (typeof window !== "undefined" && !AppCheckInstance) {
  import("firebase/app-check").then(
    ({ initializeAppCheck, ReCaptchaV3Provider }) => {
      const appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(
          process.env.REACT_APP_RECAPTCHA_SITE_KEY as string
        ),
        isTokenAutoRefreshEnabled: true,
      });
      (window as any).AppCheckInstance = appCheck;
    }
  );
}

// const appCheck =  initializeAppCheck(app, {
//   provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY as string),
//   isTokenAutoRefreshEnabled: true,
// });

export { auth, db, app, functions, storage, messaging, onMessage, getToken };
